export default __webpack_public_path__ + "static/home-page-bio-5-e192113bd5ef08d23344c43862f0959b.webp";